module.exports = __webpack_public_path__ + "img/20.f0616503.svg";